import axios from "axios";

export class ProgressService {
  GetProgress(studyInstanceUID) {
    const servico = `${window.config.dataSources[0].configuration['wadoRoot']}/S3/${studyInstanceUID}`;
    return axios.get(`${servico}/GetProgress`);
  }
}
